import DesSearchFilterViewModel from 'viewmodel/DesSearchFilterViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesSearchFilter extends DesBaseCatalogAcc {
    constructor() {
        super(DesSearchFilterViewModel);
    }

    get provider() {
        return this.getAttribute('provider');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get queryString() {
        return this.getAttribute('querystring') || this.getAttribute('query-string')
    }

    get contentPath() {
        return this.getAttribute('content-path');
    }

    /* Check the attribute value of filter unit if it is other than mm/inch
       then it set to the empty string and default result have shown.
    */
    get filterUnit() {
        return this.getAttribute(DesAccConstants.FILTER_UNIT);
    }
    getProps() {
        return {
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            querystring: this.queryString,
            contentpath: this.contentPath,
            hideelements: this.hideElements,
            filterunit: this.filterUnit
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'query-string', 'content-path', 'hide-elements', DesAccConstants.FILTER_UNIT];
    }
}

if (!window.customElements.get('des-search-filter')) {
    window.customElements.define('des-search-filter', DesSearchFilter);
}
